import React from 'react';

/**
 * Small rounded-rect chip for skills / tools / keywords.
 *  - tone 'light': solid navy-tinted background on light layouts
 *  - tone 'navy':  translucent, white-bordered on navy layouts
 * Sharp corners (radius-sm), no icons inside.
 */
const Tag = ({ children, tone = 'light', className = '' }) => {
  const styles =
    tone === 'navy'
      ? 'border border-white/25 bg-white/5 text-[#CBDBEC]'
      : 'border border-navy-600/15 bg-navy-600/10 text-navy-700';
  return (
    <span
      className={`inline-block rounded-sm px-2.5 py-1 text-[11px] font-medium leading-none tracking-wide ${styles} ${className}`}
    >
      {children}
    </span>
  );
};

export default Tag;
